export default {
    empty: () => {
        return {
            type: 'EMPTY'
        }
    }
}




// WEBPACK FOOTER //
// ./src/view/action/index.js